import React, {useEffect, useState} from 'react';
import { Card, Table, Badge, Dropdown, Pagination } from 'react-bootstrap';
import {authService} from "../../services/authService";
import NotificationService from "../../services/NotificationService";
import {userService} from "../../services/userService";
import {businessYearService} from "../../services/businessYearService";
import eventEmitter from "../../shared/eventEmitter";
import {EventEmitterTypes} from "../../shared/eventEmitterEnum";
import {useNavigate} from "react-router-dom";
import BlackoutDatesModal from "./modals/BlackoutDatesModal";
import {CustomToggle} from "../../shared/components/CustomYearlySettingsToggleOptions";
import ConfirmationModal from "../ConfirmationModal";




export interface Settings {
    created: Date,
    current: boolean,
    maximumWorkAmountPerDay: number,
    scheduleEndDate: Date,
    scheduleStartDate: Date,
    year: number
}

interface YearlySettingsDetailsProps {
    details: Settings;
}

interface BlackoutDate {
    blackoutDateId: number;
    date: Date;
    name: string;
}

const BlackoutDatesCard: React.FC<YearlySettingsDetailsProps> = ({details}) => {
    const [blackoutDates, setBlackoutDates] = useState<BlackoutDate[]>([]);
    const [activeModalData, setActiveModalData] = useState<any>();
    const [showModal, setShowModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteRecordData, setDeleteRecordData] = useState(null);

    function addOrdinal(day) {
        if (day >= 11 && day <= 13) {
            return `${day}th`;
        }
        switch (day % 10) {
            case 1:
                return `${day}st`;
            case 2:
                return `${day}nd`;
            case 3:
                return `${day}rd`;
            default:
                return `${day}th`;
        }
    }
    function formatDate(dateStr) {
        const date = new Date(dateStr);
        const month = date.toLocaleString('en-US', { timeZone: 'UTC', month: "long"});
        const day = date.getUTCDate();
        return `${month} ${addOrdinal(day)}`;
    }
    useEffect(() => {
        businessYearService.getBlackoutSchedule(details.year).then(r => setBlackoutDates(r));
    }, []);
    
    const deleteRecord = () => {
        businessYearService.deleteBlackoutSchedule(details.year, deleteRecordData).then(r => eventEmitter.emit(EventEmitterTypes.REFRESH_LOADED_YEAR_BLACKOUT));
    }

    useEffect(() => {
        const refreshListener = () => {
            businessYearService.getBlackoutSchedule(details.year).then(r => setBlackoutDates(r));
        };

        eventEmitter.on(EventEmitterTypes.REFRESH_LOADED_YEAR_BLACKOUT, refreshListener);

        return () => {
            eventEmitter.off(EventEmitterTypes.REFRESH_LOADED_YEAR_BLACKOUT, refreshListener);
        };
    }, []);

    return (<>
        <div className="card yearlySettingsCard">
            <div className="cardHeader">
                <h2 className="">
                                    <span className="cuteIcon red">
                                        <i className="fa-solid fa-calendar-xmark"></i>
                                    </span>
                    Blackout Dates
                </h2>
                <div className="cardAction">
                    <button type="button" className="btn btn-settings" onClick={() => {
                        setActiveModalData(null);
                        setShowModal(true);
                    }}>
                        <i className="fa-regular fa-plus"></i> add
                    </button>
                </div>
            </div>
            <div className="cardTable">
                <table className="table table-sm table-hover align-middle">
                    <thead>
                    <tr>
                        <th>Name</th>
                        <th>Date</th>
                        <th className="text-end">Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    {blackoutDates.map(date => {
                        return (
                        <tr>
                            <td>{date.name}</td>
                            <td>{formatDate(date.date)}</td>
                            <td className="text-end">
                                <Dropdown style={{display: 'flex', justifyContent: 'flex-end'}} align="end"
                                          className="text-end">
                                    <Dropdown.Toggle as={CustomToggle} id="priceSqFtBtn">
                                        <i className="fa-solid fa-ellipsis"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item
                                            onClick={() => {
                                                setActiveModalData(date);
                                                setShowModal(true);
                                            }}
                                        >
                                            <i className="fa-light fa-pencil fa-fw"></i> Edit
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                            className={'text-danger'}
                                            onClick={() => {
                                                setShowDeleteModal(true);
                                                setDeleteRecordData(date.blackoutDateId)
                                            }}
                                        >
                                            <i className="fa-light fa-trash fa-fw"></i> Delete
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </td>
                        </tr>
                        )})}
                    </tbody>
                </table>
            </div>
        </div>
        <BlackoutDatesModal details={activeModalData} year={details.year} show={showModal} toggle={() => setShowModal(false)}/>
        <ConfirmationModal show={showDeleteModal} toggle={() => setShowDeleteModal(false)} onConfirm={deleteRecord}/>
    </>);
};

export default BlackoutDatesCard;
